import { useState, useEffect } from 'react';
import BaseModal from '@c/modals/BaseModal';
import type { UserBike } from 'models/shared';
import SearchByVehicleForm from './SearchByVehicleForm';
import { useAuth } from 'context/AuthContext';

type DesktopSearchByVehicleProps = {
  isOpen: boolean;
  dismiss: () => void;
  onBikeComplete: (bike: UserBike, fromGarage?: boolean) => void;
  variant?: 'add-to-garage' | 'filter';
  initialBike?: Partial<UserBike> | null;
};

export default function DesktopSearchByVehicle({
  isOpen,
  dismiss,
  onBikeComplete,
  variant = 'filter',
  initialBike,
}: DesktopSearchByVehicleProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const { userDoc } = useAuth();

  useEffect(() => {
    if (
      isOpen &&
      initialBike?.year &&
      initialBike?.make &&
      initialBike?.model &&
      !userDoc?.bikes.length
    ) {
      setSearchQuery(
        `${initialBike.year} ${initialBike.make} ${initialBike.model}`
      );
    } else if (isOpen && !initialBike) {
      setSearchQuery('');
    }
  }, [isOpen, initialBike, userDoc?.bikes.length]);

  return (
    <BaseModal
      isOpen={isOpen}
      dismiss={dismiss}
      title={
        variant === 'add-to-garage'
          ? 'Add Vehicle to Your Garage'
          : userDoc
          ? 'Find parts that fit'
          : 'Find Your Vehicle'
      }
    >
      <div className="h-[70rem] w-[50rem] overflow-y-auto p-8 sm:w-[65rem]">
        <SearchByVehicleForm
          onBikeComplete={onBikeComplete}
          onDismiss={dismiss}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      </div>
    </BaseModal>
  );
}
